<template>
    <div>
        <div :class="enableConfigForm">
            <v-layout row wrap v-for="field in idpConfig[identityProvider]['idpGeneralFields']" :key="field.display_name">
                <v-flex xs3 class="pa-2 ma-2 pt-5">
                    {{field.display_name}}
                </v-flex>
                <v-flex xs8 class="pa-2">
                    <v-text-field
                                :class="enableConfigForm"
                                :placeholder="field.display_name"
                                v-model="ssoFormData[field.apiField]">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs3 class="pa-2 ma-2 pt-4">
                    Api access
                </v-flex>
                <v-flex xs8 class="pb-2">
                    <v-radio-group v-model="ssoConfigApiAccess" row>
                        <v-radio v-for="(idp, index) in identityProviderApiLabels" :key="index"
                            :label="idp.label"
                            :value="idp.value"
                        ></v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-for="field in idpConfig[identityProvider]['idpApiFields']" :key="field.display_name" :class="!ssoConfigApiAccess ? 'disabled' : '' ">
                <v-flex xs3 class="pa-2 ma-2 pt-5">
                    {{field.display_name}}
                </v-flex>
                <v-flex xs8 class="pa-2">
                    <v-text-field
                                :class="enableConfigForm"
                                :placeholder="field.display_name"
                                v-model="ssoFormData[field.apiField]"
                                :append-icon="field.apiField == 'client_secret' ? (showSecret ? 'mdi-eye':'mdi-eye-off') : ''"
                                :type="field.apiField == 'client_secret' ? (showSecret? 'text':'password') : ''"
                                @click:append="field.apiField == 'client_secret' ? (showSecret=!showSecret) : ''"
                                >
                    </v-text-field>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>
<script>
export default {
    name: 'idpSSOConfiguration',
    props: {
        ssoConfig: {
            type: Object,
            default: {}
        },
        identityProvider: {
            type: String,
            default: 'azure'
        },
        enableConfigForm: {
            type: String
        }
    },
    data() {
        return {
            idpConfig: {
                'okta': {
                    idpGeneralFields: [
                        {'display_name': 'Issuer URL', 'apiField': 'idp_id', 'status': ''},
                        {'display_name': 'Audience Restriction', 'apiField': 'entity_id', 'status': ''},
                        {'display_name': 'Sign on URL', 'apiField': 'login_url', 'status': ''},
                        {'display_name': 'Sign out URL', 'apiField': 'logout_url', 'status': ''}
                    ],
                    idpApiFields: [
                        {'display_name': 'Domain Name', 'apiField': 'idp_tenant_or_domain_name', 'status': ''},
                        {'display_name': 'Application ID', 'apiField': 'principle_or_app_id', 'status': ''},
                        {'display_name': 'API key', 'apiField': 'client_secret', 'status': ''}
                    ]
                },
                'azure': {
                    idpGeneralFields:[
                        {'display_name': 'Azure AD Identifier', 'apiField': 'idp_id', 'status': ''},
                        {'display_name': 'Entity Id', 'apiField': 'entity_id', 'status': ''},
                        {'display_name': 'Login URL', 'apiField': 'login_url', 'status': ''},
                        {'display_name': 'Logout Url', 'apiField': 'logout_url', 'status': ''}
                    ],
                    idpApiFields: [
                        {'display_name': 'Application (Client) Id ', 'apiField': 'client_id', 'status': ''},
                        {'display_name': 'Tenant Name', 'apiField': 'idp_tenant_or_domain_name', 'status': ''},
                        {'display_name': 'Object Id', 'apiField': 'principle_or_app_id', 'status': ''},
                        {'display_name': 'Client Secret', 'apiField': 'client_secret', 'status': ''}
                    ]
                },
                'onelogin': {
                    idpGeneralFields: [
                        {'display_name': 'Issuer URL', 'apiField': 'idp_id', 'status': ''},
                        {'display_name': 'SAML 2.0 Endpoint (HTTP)', 'apiField': 'login_url', 'status': ''},
                        {'display_name': 'SLO Endpoint (HTTP)', 'apiField': 'logout_url', 'status': ''}
                    ],
                    idpApiFields: [
                        {'display_name': 'Client Id', 'apiField': 'client_id', 'status': ''},
                        {'display_name': 'Domain Name', 'apiField': 'idp_tenant_or_domain_name', 'status': ''},
                        {'display_name': 'Application ID', 'apiField': 'principle_or_app_id', 'status': ''},
                        {'display_name': 'Client Secret', 'apiField': 'client_secret', 'status': ''}
                    ]
                },
            },
            ssoFormData: {},
            ssoConfigApiAccess: false,
            identityProviderApiLabels: [
                {label: 'Yes', value: true},
                {label: 'No', value: false},
            ],
            showSecret: false
        }
    },
    watch: {
        ssoConfigApiAccess() {
            var self = this;
            self.ssoFormData.idp_api_access = self.ssoConfigApiAccess;
        },
        ssoConfig() {
            var self = this;
            self.ssoFormData = self.ssoConfig;
            self.ssoConfigApiAccess = self.ssoFormData.idp_api_access;
        }
    },
    methods:{
        getssoFormData() {
            var self = this;
            self.$emit('idpSSOConfigFormData', self.ssoFormData);
        }
    }
}
</script>